module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feed"
  }, [_c('transition', {
    attrs: {
      "name": "feature",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "feed__featured"
  }, [(_vm.featuredEvent) ? _c('event-preview', {
    attrs: {
      "evt": _vm.featuredEvent,
      "featured": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('event-grid', {
    staticClass: "feed__grid",
    attrs: {
      "events": _vm.events
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "feed__nav"
  }, [_c('router-link', {
    staticClass: "paging paging--prev",
    attrs: {
      "to": _vm.prevPage || '',
      "tag": "button",
      "data-disabled": !_vm.prevPage
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "paging",
    attrs: {
      "to": _vm.nextPage || '',
      "tag": "button",
      "data-disabled": !_vm.nextPage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a8f4447!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/events/EventCalendar.vue
// module id = 633
// module chunks = 1